const path = require('path')

class Logger {
  constructor (options) {
    this.debug = true

    this.filter = true
    this.strictFilter = false
    this.enabledCategories = []
    this.disabledCategories = []

    this.where = ''
  }

  enable (category) {
    if (typeof category === 'undefined') {
      this.debug = true

      this.disabledCategories = []
    }

    if (this.enabledCategories.includes(category)) {
      return
    }
    this.enabledCategories.push(category)
    this.disabledCategories = this.disabledCategories.filter(c => {
      return c !== category
    })
  }

  disable (category) {
    if (typeof category === 'undefined') {
      this.debug = false

      this.enabledCategories = []
    }

    if (this.disabledCategories.includes(category)) {
      return
    }
    this.disabledCategories.push(category)
    this.enabledCategories = this.enabledCategories.filter(c => {
      return c !== category
    })
  }

  _pass (category) {
    if (!this.filter) {
      return
    }

    return this.strictFilter
      ? this.enabledCategories.includes(category) && !this.disabledCategories.includes(category)
      : this.enabledCategories.includes(category) || !this.disabledCategories.includes(category)
  }

  _caller () {
    const stack = ((new Error()).stack).split('\n')

    let current = null

    for (let i = 0; i < stack.length; i++) {
      const context = /at\s.+\s\((.+\/([^/]+):\d+:\d+)\)/.exec(stack[i])

      if (context === null) {
        continue
      }

      this.where = context[1]
      const filename = context[2]
      const f = path.basename(filename).replace(/\.vue$/i, '')

      if (!current) {
        current = f
      }

      if (f !== current) {
        return f
      }
    }

    return 'default'
  }

  error (...args) {
    return this._log('error', ...args)
  }

  log (...args) {
    return this._log('log', ...args)
  }

  _log (f, message, context, category, undef) {
    const caller = this._caller()
    category = category || caller

    if (!this.debug) {
      // debug disabled
      return
    }
    //
    if (!this._pass(category)) {
      return
    }

    if (typeof console === 'undefined') {
      // ooops
      return
    }

    if (typeof console[f] !== 'function') {
      console.error('Method [' + f + '] not implemented')
      return
    }

    const prefix = '[' + category + ']'
    message = prefix + ' ' + message// + ' (' + this.where + ')'

    if (typeof context !== 'undefined') {
      console[f](message, context)
    } else {
      console[f](message)
    }

    this.where = ''
  }
}

const logger = new Logger()
export default logger
